import { proxy } from 'valtio';

const gettingStartedState = proxy<{
    open: boolean;
}>({
    open: true,
});

export { gettingStartedState };
